import { CardContent, CardHeader, Collapse, Divider, Grid, IconButton, Paper, Typography } from '@material-ui/core'
import ClearIcon from '@material-ui/icons/Clear'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import FilterIcon from '@material-ui/icons/FilterList'
import { useState } from 'react'
import { CustomButton } from 'components/CustomButton'

import useStyles from './styles'

export const WrapperFiltros = (props) => {
  const { handleLimparFiltros, handleFiltrar, disabledFiltrar, error, children } = props 
  const classes = useStyles()
  const [filtroAberto, setFiltroAberto] = useState(false)

  return (
    <Paper className={classes.cardFiltros} variant="outlined">
      <CardHeader onClick={() => setFiltroAberto(!filtroAberto)} 
        avatar={<FilterIcon color="action" />}
        title={
          <Typography variant="h6" className={classes.cardTitle}>
            Filtros de Pesquisa
          </Typography>
        }
        subheader={<Typography variant="body2" >{error ? "Não foi possível carregar algumas opções de filtros." : ""}</Typography>}
        action={
          <IconButton onClick={() => setFiltroAberto(!filtroAberto)} aria-expanded={filtroAberto} size="small">
            {filtroAberto ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        }
        className={classes.cardHeader}
      />
      <Divider />
      <Collapse in={filtroAberto}>
        <CardContent className={classes.cardContent}>
          <Grid container spacing={3}>
            {children}
          </Grid>
          <div className={classes.cardActions}>
            <CustomButton 
              onClick={handleLimparFiltros} 
              startIcon={<ClearIcon />}
              variant="standard"
              color="error"
            >
              Limpar
            </CustomButton>
            <CustomButton
              colorType="primary"
              disabled={disabledFiltrar}
              onClick={handleFiltrar}
            >
              Filtrar
            </CustomButton>
          </div>
        </CardContent>
      </Collapse>
    </Paper>
  )
}
